import React, { PropsWithChildren, useEffect, useState } from 'react'
import {
  DropDownListBlurEvent,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
import DropdownOption from './DropdownOption';
import SearchableDropdown from './SearchableDropdown';
import { FrequencyTypeEnum } from '../../data/entities';

interface SearchableFrequencyTypeDropdownProps extends PropsWithChildren {
  value?: any;
  name: string;
  isInvalid?: boolean;
  onBlur?: (e: DropDownListBlurEvent) => void;
  onChange?: (e: DropDownListChangeEvent) => void;
  onSelect?: (value: DropdownOption) => void;
  placeholder?: string;
}

export const SearchableFrequencyTypeDropdown = React.forwardRef(
  (
    props: Readonly<SearchableFrequencyTypeDropdownProps>,
    ref: React.ForwardedRef<HTMLSelectElement | null>
  ) => {
    const [options, setOptions] = useState<DropdownOption[]>([]);

    useEffect(() => {
    
      const frequencyTypeOptions = Object.values(FrequencyTypeEnum).map<DropdownOption>((type)=>({
        value: type.toString(),
        text: type.toString()
      }))
      setOptions(frequencyTypeOptions)

    }, []);

    const getValue = () => {
      if (props.value) {
        return options.find((option) => option.value === props.value);
      }
    }

    return (
      <SearchableDropdown
        defaultItem={{ text: "Select an option", value: "" }}
        label="Frequency Type"
        name={props.name}
        options={options}
        value={getValue()}
        onChange={props.onChange}
        onSelect={props.onSelect}
        isInvalid={props.isInvalid}
      >
        {props.children}
      </SearchableDropdown>
    );
  }
);

export default SearchableFrequencyTypeDropdown
